module.exports = __webpack_public_path__ + "static/media/ece1.8d51099e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ece1.jpg
// module id = 5821
// module chunks = 0